module.exports = __webpack_public_path__ + "static/media/TL_DR_Demo.3e0cda6b.gif";